import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";

export type BuriedChecksPolar = {
  is_component_buried: PolarYesNoUndefined;
};
type BuriedChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof BuriedChecksPolar }) => void;
  polarQuestions: BuriedChecksPolar;
};
export default function BuriedChecks({ onHandleYesNo, polarQuestions }: BuriedChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Is the component buried?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "is_component_buried" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "is_component_buried" });
        }}
        selection={polarQuestions.is_component_buried}
      />
    </>
  );
}
